var scrollToChildElement = function scrollToChildElement(parent, child) {
  var clientHeight = parent.clientHeight;

  if (parent.scrollHeight > clientHeight) {
    var scrollTop = parent.scrollTop;
    var scrollBottom = clientHeight + scrollTop;
    var childBottom = child.offsetTop + child.offsetHeight;

    if (childBottom > scrollBottom) {
      parent.scrollTop = childBottom - clientHeight;
    } else if (child.offsetTop < scrollTop) {
      parent.scrollTop = child.offsetTop;
    }
  }
};

var useListScrollTo = function useListScrollTo(internalRef, itemRefs) {
  var scrollTo = function scrollTo(index) {
    if (internalRef && internalRef.current) {
      if (index !== undefined) {
        var activeRef = itemRefs[index];

        if (activeRef && activeRef.current) {
          scrollToChildElement(internalRef.current, activeRef.current);
        }
      } else {
        internalRef.current.scrollTop = 0;
      }
    }
  };

  return {
    scrollTo: scrollTo
  };
};

export { useListScrollTo };
//# sourceMappingURL=useListScrollTo.js.map
